export default __webpack_public_path__ + "static/media/Campana.dc994c4e.svg";